import { proxyCustomElement, HTMLElement, createEvent, h, Fragment } from '@stencil/core/internal/client';
import { C as CURRENT_MODULE } from './index2.js';
import { s as state } from './index3.js';
import { d as defineCustomElement$m } from './button-base2.js';
import { d as defineCustomElement$l } from './nl-confirm-logout2.js';
import { d as defineCustomElement$k } from './nl-connect2.js';
import { d as defineCustomElement$j } from './nl-iframe2.js';
import { d as defineCustomElement$i } from './nl-import-flow2.js';
import { d as defineCustomElement$h } from './nl-info2.js';
import { d as defineCustomElement$g } from './nl-info-extension2.js';
import { d as defineCustomElement$f } from './nl-loading2.js';
import { d as defineCustomElement$e } from './nl-local-signup2.js';
import { d as defineCustomElement$d } from './ns-login-status.js';
import { d as defineCustomElement$c } from './nl-otp-migrate2.js';
import { d as defineCustomElement$b } from './nl-previously-logged2.js';
import { d as defineCustomElement$a } from './nl-select2.js';
import { d as defineCustomElement$9 } from './nl-signin2.js';
import { d as defineCustomElement$8 } from './nl-signin-bunker-url2.js';
import { d as defineCustomElement$7 } from './nl-signin-connection-string2.js';
import { d as defineCustomElement$6 } from './nl-signin-otp2.js';
import { d as defineCustomElement$5 } from './nl-signin-read-only2.js';
import { d as defineCustomElement$4 } from './nl-signup2.js';
import { d as defineCustomElement$3 } from './nl-welcome2.js';
import { d as defineCustomElement$2 } from './nl-welcome-signin2.js';
import { d as defineCustomElement$1 } from './nl-welcome-signup2.js';

import { baseCss } from './css.js';
const nlAuthCss = baseCss;

const NlAuthStyle0 = nlAuthCss;

const NlAuth = /*@__PURE__*/ proxyCustomElement(class NlAuth extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.nlCloseModal = createEvent(this, "nlCloseModal", 7);
        this.nlChangeDarkMode = createEvent(this, "nlChangeDarkMode", 7);
        this.nlNostrConnectDefaultCancel = createEvent(this, "nlNostrConnectDefaultCancel", 7);
        this.prevPath = '';
        this.theme = 'default';
        this.bunkers = '';
        this.startScreen = CURRENT_MODULE.WELCOME;
        this.authMethods = [];
        this.hasExtension = false;
        this.hasOTP = false;
        this.isLoading = false;
        this.isLoadingExtension = false;
        this.isOTP = false;
        this.authUrl = '';
        this.iframeUrl = '';
        this.error = '';
        this.localSignup = false;
        this.signupNjump = false;
        this.njumpIframe = '';
        this.accounts = [];
        this.recents = [];
        this.darkMode = false;
        this.welcomeTitle = '';
        this.welcomeDescription = '';
        this.connectionString = '';
        this.connectionStringServices = [];
    }
    watchLoadingHandler(newValue) {
        state.isLoading = newValue;
    }
    watchLoadingExtensionHandler(newValue) {
        state.isLoadingExtension = newValue;
    }
    watchOTPHandler(newValue) {
        state.isOTP = newValue;
    }
    watchAuthUrlHandler(newValue) {
        state.authUrl = newValue;
    }
    watchIframeUrlHandler(newValue) {
        state.iframeUrl = newValue;
    }
    watchNjumpIframeHandler(newValue) {
        state.njumpIframe = newValue;
    }
    watchErrorHandler(newValue) {
        state.error = newValue;
    }
    handleClose() {
        this.nlCloseModal.emit();
    }
    handleChangeDarkMode() {
        this.nlChangeDarkMode.emit(!this.darkMode);
    }
    componentWillLoad() {
        // init state
        state.path = [this.startScreen];
        state.error = '';
        state.iframeUrl = '';
        state.authUrl = '';
        state.isLoading = false;
        state.isLoadingExtension = false;
        state.isOTP = false;
        console.log('path', state.path);
    }
    handleClickToBack() {
        state.path.pop();
        state.path = [...state.path];
        // reset
        state.isLoading = false;
        state.isLoadingExtension = false;
        state.authUrl = '';
        state.isOTP = false;
    }
    switchSignSignUpStrategy(str) {
        if (CURRENT_MODULE.LOCAL_SIGNUP === str) {
            state.path = [CURRENT_MODULE.WELCOME, CURRENT_MODULE.WELCOME_SIGNUP, str];
            return;
        }
        state.path = [CURRENT_MODULE.WELCOME, str];
    }
    render() {
        const classWrapper = `w-full h-full fixed top-0 start-0 z-[80] overflow-x-hidden overflow-y-auto flex items-center ${this.darkMode ? 'dark' : ''}`;
        const currentModule = state.path.at(-1);
        if (currentModule !== this.prevPath && this.prevPath === CURRENT_MODULE.CONNECTION_STRING) {
            this.nlNostrConnectDefaultCancel.emit();
        }
        this.prevPath = currentModule;
        const renderModule = () => {
            if (state.isOTP)
                return h("nl-signin-otp", null);
            // @ts-ignore
            // const t: CURRENT_MODULE = 'import' // lastValuePath
            switch (currentModule) {
                case CURRENT_MODULE.WELCOME:
                    return h("nl-welcome", { titleWelcome: this.welcomeTitle || undefined, description: this.welcomeDescription || undefined });
                case CURRENT_MODULE.LOGIN:
                    return h("nl-signin", null);
                case CURRENT_MODULE.SIGNUP:
                    return h("nl-signup", { bunkers: this.bunkers });
                case CURRENT_MODULE.LOCAL_SIGNUP:
                    return h("nl-local-signup", { signupNjump: this.signupNjump });
                case CURRENT_MODULE.CONFIRM_LOGOUT:
                    return h("nl-confirm-logout", null);
                case CURRENT_MODULE.IMPORT_FLOW:
                    return h("nl-import-flow", { services: this.connectionStringServices });
                case CURRENT_MODULE.IMPORT_OTP:
                    return h("nl-otp-migrate", { services: this.connectionStringServices });
                case CURRENT_MODULE.INFO:
                    return h("nl-info", null);
                case CURRENT_MODULE.EXTENSION:
                    return h("nl-info-extension", null);
                case CURRENT_MODULE.LOGIN_READ_ONLY:
                    return h("nl-signin-read-only", null);
                case CURRENT_MODULE.LOGIN_BUNKER_URL:
                    return h("nl-signin-bunker-url", null);
                case CURRENT_MODULE.LOGIN_OTP:
                    return h("nl-signin-otp", null);
                case CURRENT_MODULE.WELCOME_LOGIN:
                    return h("nl-welcome-signin", { hasOTP: this.hasOTP, authMethods: this.authMethods, hasExtension: this.hasExtension });
                case CURRENT_MODULE.WELCOME_SIGNUP:
                    return h("nl-welcome-signup", null);
                case CURRENT_MODULE.CONNECTION_STRING:
                    return h("nl-signin-connection-string", { connectionString: this.connectionString });
                case CURRENT_MODULE.CONNECT:
                    return h("nl-connect", { connectionStringServices: this.connectionStringServices, authMethods: this.authMethods });
                case CURRENT_MODULE.PREVIOUSLY_LOGGED:
                    return h("nl-previously-logged", { accounts: this.accounts, recents: this.recents });
                case CURRENT_MODULE.IFRAME:
                    return h("nl-iframe", { iframeUrl: this.authUrl });
                default:
                    return h("nl-welcome", null);
            }
        };
        const showLogin = state.isOTP ||
            (currentModule !== CURRENT_MODULE.INFO &&
                currentModule !== CURRENT_MODULE.CONFIRM_LOGOUT &&
                currentModule !== CURRENT_MODULE.IMPORT_FLOW &&
                currentModule !== CURRENT_MODULE.WELCOME &&
                currentModule !== CURRENT_MODULE.EXTENSION &&
                currentModule !== CURRENT_MODULE.IFRAME &&
                currentModule !== CURRENT_MODULE.PREVIOUSLY_LOGGED);
        const showSignup = currentModule !== CURRENT_MODULE.IFRAME &&
            (!this.authMethods.length || (!this.localSignup && this.authMethods.includes('connect')) || (this.localSignup && this.authMethods.includes('local')));
        return (h("div", { class: `theme-${this.theme}`, dir: "ltr" }, h("div", { class: classWrapper }, h("div", { onClick: () => this.handleClose(), class: "absolute top-0 left-0 w-full h-full bg-gray-500 bg-opacity-75 z-[80]" }), h("div", { class: "nl-bg relative z-[81] w-full flex flex-col rounded-xl sm:max-w-lg sm:w-full sm:mx-auto" }, h("div", { class: `flex justify-between items-center py-3 px-4` }, h("div", { class: "flex gap-2 items-center" }, h("svg", { class: "w-7 h-7", width: "225", height: "224", viewBox: "0 0 225 224", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("rect", { width: "224.047", height: "224", rx: "64", fill: "#6951FA" }), h("path", { d: "M162.441 135.941V88.0593C170.359 85.1674 176 77.5348 176 68.6696C176 57.2919 166.708 48 155.33 48C143.953 48 134.661 57.2444 134.661 68.6696C134.661 77.5822 140.302 85.1674 148.219 88.0593V135.941C147.698 136.13 147.176 136.367 146.655 136.604L87.3956 77.3452C88.6282 74.6904 89.2919 71.7511 89.2919 68.6696C89.2919 57.2444 80.0474 48 68.6696 48C57.2919 48 48 57.2444 48 68.6696C48 77.5822 53.6415 85.1674 61.5585 88.0593V135.941C53.6415 138.833 48 146.465 48 155.33C48 166.708 57.2444 176 68.6696 176C80.0948 176 89.3393 166.708 89.3393 155.33C89.3393 146.418 83.6978 138.833 75.7807 135.941V88.0593C76.3022 87.8696 76.8237 87.6326 77.3452 87.3956L136.604 146.655C135.372 149.31 134.708 152.249 134.708 155.33C134.708 166.708 143.953 176 155.378 176C166.803 176 176.047 166.708 176.047 155.33C176.047 146.418 170.406 138.833 162.489 135.941H162.441Z", fill: "white" })), h("p", { class: "font-bold nl-logo text-base" }, "Nostr ", h("span", { class: "font-light" }, "Login"))), h("div", { class: "flex gap-1" }, h("button", { onClick: () => this.handleChangeDarkMode(), type: "button", class: "nl-action-button flex justify-center items-center w-7 h-7 text-sm font-semibold rounded-full border border-transparent" }, h("span", { class: "sr-only" }, "Change theme"), this.darkMode ? (h("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", "stroke-width": "1.5", stroke: "currentColor", class: "flex-shrink-0 w-5 h-5" }, h("path", { "stroke-linecap": "round", "stroke-linejoin": "round", d: "M12 3v2.25m6.364.386-1.591 1.591M21 12h-2.25m-.386 6.364-1.591-1.591M12 18.75V21m-4.773-4.227-1.591 1.591M5.25 12H3m4.227-4.773L5.636 5.636M15.75 12a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0Z" }))) : (h("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", "stroke-width": "1.5", stroke: "currentColor", class: "flex-shrink-0 w-5 h-5" }, h("path", { "stroke-linecap": "round", "stroke-linejoin": "round", d: "M21.752 15.002A9.72 9.72 0 0 1 18 15.75c-5.385 0-9.75-4.365-9.75-9.75 0-1.33.266-2.597.748-3.752A9.753 9.753 0 0 0 3 11.25C3 16.635 7.365 21 12.75 21a9.753 9.753 0 0 0 9.002-5.998Z" })))), !state.isLoading && (h("button", { onClick: () => (state.path = [...state.path, CURRENT_MODULE.INFO]), type: "button", class: "nl-action-button flex justify-center items-center w-7 h-7 text-sm font-semibold rounded-full border border-transparent" }, h("span", { class: "sr-only" }, "Info"), h("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", "stroke-width": "1.5", stroke: "currentColor", class: "flex-shrink-0 w-5 h-5" }, h("path", { "stroke-linecap": "round", "stroke-linejoin": "round", d: "m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z" })))), h("button", { onClick: () => this.handleClose(), type: "button", class: "nl-action-button flex justify-center items-center w-7 h-7 text-sm font-semibold rounded-full border border-transparent" }, h("span", { class: "sr-only" }, "Close"), h("svg", { class: "flex-shrink-0 w-5 h-5", xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }, h("path", { d: "M18 6 6 18" }), h("path", { d: "m6 6 12 12" }))))), state.path.length > 1 && !state.isLoading && (h("div", { class: "p-4" }, h("button", { onClick: () => this.handleClickToBack(), type: "button", class: "nl-action-button flex justify-center items-center w-7 h-7 text-sm font-semibold rounded-full border border-transparent  dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600", "data-hs-overlay": "#hs-vertically-centered-modal" }, h("span", { class: "sr-only" }, "Back"), h("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", "stroke-width": "1.5", stroke: "currentColor", class: "flex-shrink-0 w-5 h-5" }, h("path", { "stroke-linecap": "round", "stroke-linejoin": "round", d: "M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18" }))))), state.isLoading || state.authUrl ? (h("nl-loading", { path: currentModule })) : (h(Fragment, null, renderModule(), showLogin && (h(Fragment, null, currentModule === CURRENT_MODULE.WELCOME_SIGNUP || currentModule === CURRENT_MODULE.SIGNUP || currentModule === CURRENT_MODULE.LOCAL_SIGNUP ? (h("div", { class: "p-4 overflow-y-auto" }, h("p", { class: "nl-footer font-light text-center text-sm pt-3 max-w-96 mx-auto" }, "If you already have a profile please", ' ', h("span", { onClick: () => this.switchSignSignUpStrategy(CURRENT_MODULE.WELCOME_LOGIN), class: "cursor-pointer text-blue-400" }, "log in"), "."))) : (showSignup && (h("div", { class: "p-4 overflow-y-auto" }, h("p", { class: "nl-footer font-light text-center text-sm pt-3 max-w-96 mx-auto" }, "If you don't have a profile please", ' ', h("span", { onClick: () => this.localSignup ? this.switchSignSignUpStrategy(CURRENT_MODULE.LOCAL_SIGNUP) : this.switchSignSignUpStrategy(CURRENT_MODULE.WELCOME_SIGNUP), class: "cursor-pointer text-blue-400" }, "sign up"), "."))))))))))));
    }
    static get watchers() { return {
        "isLoading": ["watchLoadingHandler"],
        "isLoadingExtension": ["watchLoadingExtensionHandler"],
        "isOTP": ["watchOTPHandler"],
        "authUrl": ["watchAuthUrlHandler"],
        "iframeUrl": ["watchIframeUrlHandler"],
        "njumpIframe": ["watchNjumpIframeHandler"],
        "error": ["watchErrorHandler"]
    }; }
    static get style() { return NlAuthStyle0; }
}, [1, "nl-auth", {
        "theme": [1025],
        "bunkers": [1],
        "startScreen": [1, "start-screen"],
        "authMethods": [16],
        "hasExtension": [4, "has-extension"],
        "hasOTP": [4, "has-o-t-p"],
        "isLoading": [4, "is-loading"],
        "isLoadingExtension": [4, "is-loading-extension"],
        "isOTP": [4, "is-o-t-p"],
        "authUrl": [1, "auth-url"],
        "iframeUrl": [1, "iframe-url"],
        "error": [1],
        "localSignup": [4, "local-signup"],
        "signupNjump": [4, "signup-njump"],
        "njumpIframe": [1, "njump-iframe"],
        "accounts": [1040],
        "recents": [1040],
        "darkMode": [1028, "dark-mode"],
        "welcomeTitle": [1, "welcome-title"],
        "welcomeDescription": [1, "welcome-description"],
        "connectionString": [1, "connection-string"],
        "connectionStringServices": [16]
    }, undefined, {
        "isLoading": ["watchLoadingHandler"],
        "isLoadingExtension": ["watchLoadingExtensionHandler"],
        "isOTP": ["watchOTPHandler"],
        "authUrl": ["watchAuthUrlHandler"],
        "iframeUrl": ["watchIframeUrlHandler"],
        "njumpIframe": ["watchNjumpIframeHandler"],
        "error": ["watchErrorHandler"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["nl-auth", "button-base", "nl-confirm-logout", "nl-connect", "nl-iframe", "nl-import-flow", "nl-info", "nl-info-extension", "nl-loading", "nl-local-signup", "nl-login-status", "nl-otp-migrate", "nl-previously-logged", "nl-select", "nl-signin", "nl-signin-bunker-url", "nl-signin-connection-string", "nl-signin-otp", "nl-signin-read-only", "nl-signup", "nl-welcome", "nl-welcome-signin", "nl-welcome-signup"];
    components.forEach(tagName => { switch (tagName) {
        case "nl-auth":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, NlAuth);
            }
            break;
        case "button-base":
            if (!customElements.get(tagName)) {
                defineCustomElement$m();
            }
            break;
        case "nl-confirm-logout":
            if (!customElements.get(tagName)) {
                defineCustomElement$l();
            }
            break;
        case "nl-connect":
            if (!customElements.get(tagName)) {
                defineCustomElement$k();
            }
            break;
        case "nl-iframe":
            if (!customElements.get(tagName)) {
                defineCustomElement$j();
            }
            break;
        case "nl-import-flow":
            if (!customElements.get(tagName)) {
                defineCustomElement$i();
            }
            break;
        case "nl-info":
            if (!customElements.get(tagName)) {
                defineCustomElement$h();
            }
            break;
        case "nl-info-extension":
            if (!customElements.get(tagName)) {
                defineCustomElement$g();
            }
            break;
        case "nl-loading":
            if (!customElements.get(tagName)) {
                defineCustomElement$f();
            }
            break;
        case "nl-local-signup":
            if (!customElements.get(tagName)) {
                defineCustomElement$e();
            }
            break;
        case "nl-login-status":
            if (!customElements.get(tagName)) {
                defineCustomElement$d();
            }
            break;
        case "nl-otp-migrate":
            if (!customElements.get(tagName)) {
                defineCustomElement$c();
            }
            break;
        case "nl-previously-logged":
            if (!customElements.get(tagName)) {
                defineCustomElement$b();
            }
            break;
        case "nl-select":
            if (!customElements.get(tagName)) {
                defineCustomElement$a();
            }
            break;
        case "nl-signin":
            if (!customElements.get(tagName)) {
                defineCustomElement$9();
            }
            break;
        case "nl-signin-bunker-url":
            if (!customElements.get(tagName)) {
                defineCustomElement$8();
            }
            break;
        case "nl-signin-connection-string":
            if (!customElements.get(tagName)) {
                defineCustomElement$7();
            }
            break;
        case "nl-signin-otp":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "nl-signin-read-only":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "nl-signup":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "nl-welcome":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "nl-welcome-signin":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
        case "nl-welcome-signup":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { NlAuth as N, defineCustomElement as d };

//# sourceMappingURL=nl-auth2.js.map